module.exports = __webpack_public_path__ + "static/founder-20019801c9dbb9d84b1bd5eae611edca.png";